/**
 * @fileoverview TourSearch.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState } from 'react'
import TourTrackingForm from './TourTrackingForm';
import TourStatusCard from './TourStatusCard';
import { useTranslation } from 'react-i18next';

function TourSearch() {
  const { t } = useTranslation();
  const[showCard, setShowCard] = useState(false);
  const[tourID, setTourID] = useState(null);

  return (
    <div className='flex flex-col w-full min-h-screen pt-32 md:pt-40 pb-20'>
      <div className='px-[5%] md:px-[10%] flex flex-col items-center gap-12'>
        <div className='max-w-2xl text-center flex flex-col gap-4'>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-800'>{t('find_tour.title')}</h2>
            <p className='text-gray-500'>
                {t('find_tour.desc')}
            </p>
        </div>

        <div className='w-full max-w-md relative flex flex-col gap-6'>
          <TourTrackingForm setShowCard={setShowCard} setTourID={setTourID} />
          
          <div className={`w-full transition-all duration-500 ease-out ${showCard ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}`}>
            {showCard && <TourStatusCard tourID={tourID} />}
          </div>
        </div>
      </div>
    </div>
  )
}
export default TourSearch